import { FilterField, ModalFilterProps } from "pages/Site/pages/type";
import React, { useState, useEffect } from "react";
import { Modal } from "reactstrap";
import { Check, Button } from "shared";
import t from "utils/Lang";
import "../../../styles/modalfilter.scss";

let showAll = false;

const ModalFilter = ({
  isOpen,
  toggle,
  tableMapping,
  onApply,
}: ModalFilterProps) => {
  const onChangeAll = (checked: boolean) => (showAll = checked);
  const [fields, setFields] = useState(
    tableMapping.map((dt) => ({
      label: dt.label,
      isActive: dt.isActive,
    }))
  );
  useEffect(() => {
    showAll = false;
    setFields(
      tableMapping.map((dt) => ({
        label: dt.label,
        isActive: dt.isActive,
      }))
    );
  }, [tableMapping]);
  const close = () => {
    setFields(
      tableMapping.map((dt) => ({
        label: dt.label,
        isActive: dt.isActive,
      }))
    );
    toggle();
  };
  const apply = () => {
    const res = showAll
      ? fields.map((f) => ({ ...f, isActive: true }))
      : fields;
    onApply(res);
    toggle();
  };
  const onDefault = () => {
    onApply(
      tableMapping.map((dt) => ({
        label: dt.label,
        isActive: dt.isActive,
      }))
    );
    toggle();
  };
  const onChange = (item: FilterField) => (checked: boolean) => {
    setFields(
      fields.map((f) => {
        if (f.label == item.label) f.isActive = checked;
        return f;
      })
    );
  };
  return (
    <Modal isOpen={isOpen} toggle={toggle} style={{ padding: 30 }}>
      <div className="listing-filter__header">
        <span className="listing-filter__header__title">
          {t().site_listing__filter_column_table_label}
        </span>
        <div style={{ height: 25 }} />
        <Check
          label={t().site_listing__filter_show_all}
          checked={showAll}
          onChange={onChangeAll}
        />
      </div>
      <div className="listing-filter__body">
        <div>
          {fields.slice(0, 4).map((dt) => (
            <Check
              key={dt.label}
              label={dt.label}
              checked={dt.isActive}
              onChange={onChange(dt)}
            />
          ))}
        </div>
        <div>
          {fields.slice(4).map((dt) => (
            <Check
              key={dt.label}
              label={dt.label}
              checked={dt.isActive}
              onChange={onChange(dt)}
            />
          ))}
        </div>
      </div>
      <div className="listing-filter__footer">
        <Button
          label={t().action__apply}
          type="primary-light"
          onClick={apply}
        />
        <div style={{ width: 12 }} />
        <Button label={t().action__close} onClick={close} />
        <div style={{ flex: 1 }} />
        <Button
          label={t().action__default}
          type="primary-light"
          outline
          onClick={onDefault}
        />
      </div>
    </Modal>
  );
};

export default ModalFilter;
